module.exports = __webpack_public_path__ + "static/kevin-hart-98e7c2858f47d3f5cea8336380a6750a.jpg";